import { sumBy } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { isMarketDisabled, contractOwnershipNum } from '@/utils/helpers';

export default {
  props: {
    market: {
      type: Object,
      default: null,
    },
    dontShowOdds: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
      showSettings: false,
    };
  },
  components: {
    'small-modal': () => import('@/components/generics/modal/small/small.vue'),
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', ['isTradingEnabled', 'isLayoutMobile', 'oddsModeEnabled']),
    ...mapState('app', ['showOdds']),
    hasOwnership() {
      if (this.market === null || !this.isLoggedIn) return false;
      return sumBy(this.market.contracts, i => contractOwnershipNum(i)) > 0;
    },
    isMarketDisabled() {
      return this.market !== null && isMarketDisabled(this.market);
    },
    pricesTitle() {
      return this.isLayoutMobile ? 'Trade Prices' : 'Last Trade Price';
    },
    titleSecond() {
      if (this.dontShowOdds) {
        return this.pricesTitle;
      }
      return this.showOdds ? 'Odds' : this.pricesTitle;
    },
    titleThird() {
      return 'Ownership';
    },
    titleFourth() {
      return 'Outcome';
    },
    titleFirstMobile() {
      return this.isMarketDisabled ? 'Outcome' : '';
    },
    titleSecondMobile() {
      if (this.isMarketDisabled) {
        return '';
      }
      return this.showOdds ? 'Odds' : this.pricesTitle;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('app', ['setShowOdds']),
    onMenuToggle() {
      this.showMenu = !this.showMenu;
      this.showSettings = false;
    },
    onSettingsToggle() {
      this.showSettings = !this.showSettings;
      this.showMenu = false;
    },
    onClickOutside() {
      this.showMenu = false;
    },
    setOddsMode(value) {
      this.setShowOdds(value);
      this.showMenu = false;
      this.showSettings = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-contracts-list-header-sushi-common-betslip/market-contracts-list-header-sushi-common-betslip.js